import { palette } from './palette';
import background from '../assets/images/headerImg.webp';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .logo-image': {
        height: 46,
      },

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.accordion__collapsable-text': {
    '& .accordion__collapsable-text_anchor': {
      textDecoration: 'none',
    },
    '& .accordion__collapsable-text_code': {
      textDecoration: 'underline',
    },
    '& .accordion__collapsable-text_number': {
      textDecoration: 'underline',
    },
  },

  '.mosaic-dental-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      '@media(min-width: 900px)': {
        backgroundImage: `linear-gradient(90deg, #FFFFFF 36%, #E9F3F6 0%)`,
      },

      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .hero-title': {
          maxWidth: 500,
          lineHeight: '55px',

          '@media(min-width: 900px)': {
            lineHeight: '80px',
          },
          '@media(max-width: 900px)': {
            textAlign: 'center',
          },
        },
        '& .hero-subtitle': {
          maxWidth: 500,
          '@media(max-width: 900px)': {
            textAlign: 'center',
          },
        },
      },
      '& .section-header__cta-container': {
        '@media(max-width: 900px)': { 
          display: 'flex',
          justifyContent: 'center',
        }
      },
      '& .image-wrapper': {
        '@media(max-width: 900px)': {
          display: 'contents',
          padding: '24px 48px 24px 16px',
        },
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '@media(max-width: 900px)': {
        paddingTop: 0,
        '& .section-header__title': {
          textAlign: 'left',
        },
        '& .definition-service-title': {
          textAlign: 'left',
        }
      },
      '& .benefits-wrapper': {
        borderTop: `4px solid ${palette.text.primary}`,
        paddingTop: 48,

        '@media(min-width: 900px)': {
          paddingTop: 72,
        },
      },

      '& .section-header': {
        '@media(min-width: 900px)': {
          paddingBottom: 50,
        },
      },

      '& .definition-service-tile': {
        padding: (32, 32, 16),

        '& .definition-service-innertile': {
          '& .definition-service-title': {
            color: palette.primary.main,
          },
          '@media (max-width: 767px)': {
            '& .definition-service-description': {
              paddingBottom: 48,
              textAlign: 'left',
              borderBottom: `1px solid ${palette.divider}`,
            },
          },
        },
      },
    },

    '& .subscription-wrapper': { 
      '& .subscription-bg': {
        position: 'unset',
        height: 576,
        background: `url('./images/home-images/pricing-benefits.webp') no-repeat center`,
        backgroundSize: 'cover',
      }, 
      '@media(max-width: 900px)': { 
        '& .subscription-bg': {
          position: 'unset',
          height: 360,
          background: `url('./images/home-images/pricing-benefits-mobile.webp') no-repeat center`,
          backgroundSize: 'cover',
        },
      },
      background: palette.secondary.contrastText,
      '& .subscription-section': {
        padding: '48px 32px',
          '& .subscription-section-container': {
            '& .left-section': {
              '& .title-box': {
                '& .section-header__title': {
                  color: palette.text.highlight,
                  maxWidth: 640,
                },
                '& .section-header__subtitle': {
                  color: palette.text.highlight,
                  fontSize: '18px',
                  maxWidth: 600,
                  fontWeight: 400,
                }
              },
              '& .getstarted-button': {
                backgroundColor: palette.text.highlight,
                color: palette.text.primary,
                height: 64,
                width: 170,
                '&:hover': {
                  backgroundColor: palette.text.highlight,
                  color: palette.text.primary,
                }
              },
              '& .savings-summary-link': {
                color: palette.text.alternate,
                textDecoration: 'underline',
              }
            },
            '& .right-section': { 
              '& .planCard': {
                '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
                  background: palette.text.alternate,
                  border: `1px solid ${palette.background.primary}`,
                  opacity: 1,
                },
                '& .MuiSwitch-thumb': {
                  background: palette.text.highlight
                },
                '& .MuiSwitch-track': {
                  border: `1px solid ${palette.text.highlight}`,
                  background: palette.text.alternate,
                },
                '& .customTieredPlans': {
                  minHeight: '0px !important',
                },
                '& .planCard': {
                  backgroundColor: palette.text.primary,
                },
                '& .cptCodes': {
                  fontSize: '13px'
                },
                '& .customBenefitsContainer': {
                  minHeight: '0px !important',
                },
                '& .customUpfrontWrapper': {
                  textAlign: 'left',
                  marginTop: '18px',
                  paddingLeft: '32px',
                  paddingBottom: '40px',
                },
                '& .cardDivider': {
                  paddingTop: 0,
                  margunBottom: 12,
                },
                '&:hover': {
                  color: palette.text.primary,
                  backgroundColor: palette.text.highlight,
                },
                '@media(max-width: 900px)': {
                  '& .customCardContent': {
                    paddingLeft: '16px',
                    paddingRight: '16px'
                  },
                },
              },
              '& .plans-loader': {
                color: palette.text.highlight
              }
            },
            '& .desc-box': {
              '& .savings-summary-link': {
                color: palette.text.alternate,
              },
              '& .customMetricsDescription': {
                color: palette.text.highlight,
                fontWeight: 400,
              }
            },
            '& savings-link': {
              color: palette.text.alternate
            }
          }
      }
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: 'unset',

      '& .step-counter': {
        background: palette.text.alternate,
      },
      '& .section': {
        borderBottom: `2px solid ${palette.text.disabled}`,
      },
      '& .howitworks-wrapper': {
        '& .how-cover-image': {
          height: 'auto',
        },
      },
      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
        marginBottom: 0,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      paddingBottom: 80,
      '& .section-alternate': {
        borderBottom: `1px solid ${palette.text.disabled}`,
      },
      '@media(max-width: 900px)': { 
        '& .testimonialSection': {
          padding: '48px 32px',
        },
      },

      '& .section-header__overline-wrapper': {
        color: palette.text.alternate,
      },

      '& .testimonial-title-wrapper': {
        '& .section-header__title': {
          maxWidth: 500,
        },
      },
      '& .testimonial-container': {
        flexDirection: 'column-reverse',

        '@media(min-width: 900px)': {
          flexDirection: 'row-reverse',
        },
      },
      '& .testimonial-content-wrapper': {
        marginTop: 10,
        '@media(min-width: 900px)': {
          marginTop: -200,
        },

        '& .react-multi-carousel-track': {
          paddingTop: 60,
          '@media(min-width: 900px)': {
            paddingTop: 200,
          },
        },
        '& .custom-arrow': {
          border: 0,
          backgroundColor: 'unset',
          top: 0,
          width: 40,
          height: 40,
        },
        '& .left-arrow': {
          right: 75,
          left: 'unset',
        },
        '& .testimonial-message': {
          color: palette.text.primary,
          fontFamily: 'OpenSauceSans',
          fontWeight: 400,
        },
      },
      '& .image-wrapper': {
        display: 'flex',
        justifyContent: 'center',

        '@media(min-width: 900px)': {
          justifyContent: 'left',
        },

        '& .image': {
          height: '100%',
          width: 'auto',

          '@media(min-width: 900px)': {
            height: 414,
          },
          '@media(max-width: 900px)': {
            width: '100%',
          },
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      paddingBottom: 80,

      '& .hero-static-bg': {
        backgroundColor: 'unset',
      },
      '& .hero-static-section': {
        backgroundColor: palette.primary.main,
        borderRadius: 32,

        '@media(max-width: 900px)': {
          margin: (0, 20),
        },

        '& .section-header__title': {
          color: palette.text.highlight,
          maxWidth: 600,
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table .savings-subheader': {
        backgroundColor: palette.background.main,
        fontWeight: 600,
      },
      '& .savings-contact-card': {
        backgroundColor: palette.background.main,
      },
      '& .savings-header': {
        color: palette.text.primary,
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, & .faq-hero-section, & .faq-contact-wrapper':
      {
        backgroundColor: palette.background.main,
      },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .find-provider-section, & .plan-selection-section': {
        background: palette.background.main,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          color: palette.text.primary,
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-section': {
          '& .section-header__title': {
            color: palette.text.primary,
          },
        },
        '& .hero-static-bg': {
          backgroundColor: palette.background.main,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .checkout-hero-section': {
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          backgroundColor: palette.background.tableHead,
          opacity: '70%',
        },
      },
      '& .hero-header-title': {
        color: palette.secondary.main,
      },
      '& .hero-header-subtitle': {
        color: palette.secondary.main,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* Footer */
    '& .footer-wrapper, & .footer-wrapper a': {
      backgroundColor: palette.primary.main,
      color: palette.text.highlight
    }
  },
};
